import { render, staticRenderFns } from "./WaterHistory.vue?vue&type=template&id=2581a52a&"
import script from "./WaterHistory.vue?vue&type=script&lang=js&"
export * from "./WaterHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports